import { createMiddleware } from "@tanstack/react-start"
import { getRequestHeader } from "@tanstack/react-start/server"
import * as z from "zod"

import { captchaService } from "@repo/captcha/captcha-service"
import { logger } from "@repo/utils/logger"
import { sharedConfig } from "~/lib/config/shared"
import { badRequestResponse } from "~/lib/utils/http"

const log = logger.child({ module: "middleware/captcha-token" })

const captchaTokenSchema = z.object({
  captchaToken: z.string().optional(),
})

export const captchaTokenMiddleware = createMiddleware({
  type: "function",
}).server(async ({ next, data }) => {
  if (!sharedConfig.flags.captchaEnabled) {
    return next()
  }

  const { captchaToken } = captchaTokenSchema.parse(data)

  if (!captchaToken) {
    log.warn("Captcha token is required")
    badRequestResponse("Captcha token is required", 400)
  }

  const remoteIp =
    getRequestHeader("cf-connecting-ip") ||
    getRequestHeader("x-client-ip") ||
    getRequestHeader("x-real-ip") ||
    getRequestHeader("x-forwarded-for")

  const captchaResponse = await captchaService.validate({
    response: captchaToken,
    remoteip: remoteIp,
  })

  // The validate function returns `undefined` if the captcha service is not enabled
  if (captchaResponse === undefined) {
    return next()
  }

  if (!captchaResponse.valid) {
    log.warn("Captcha token is invalid")
    badRequestResponse("Captcha token is invalid", 403)
  }

  return next()
})
